<template>
  <div style="height: 100%">
    <sh-card card-height="100%" card-width="100%">
      <sh-empty-state
        icon="cancel"
        icon-color="red"
        label="The current user is unauthorized."
      >
      </sh-empty-state>
    </sh-card>
  </div>
</template>
<script>
export default {
  name: "UnauthUser",
  computed: {},
};
</script>
